const theme = {
	fontSize: "1.5rem",
	logoFontSize: "1.7rem",
	color: "DODGERBLUE",
	colorHover: "#1ec8ff",
	colorActive: "#1e7dff",
	borderRadius: "10px",
	btnColor: "white",
	extraLargeBreakPoint: "1400px",
	largeBreakPoint: "1100px",
	mediumBreakPoint: "1000px",
	smallBreakPoint: "700px",
	xSmallBreakPoint: "500px",
	xxSmallBreakPoint: "400px",
};

export const lightTheme = {
	...theme,
	main: "white",
	background: "#F0F2F5",
	backgroundAlt: "#eeeeee",
	backgroundHover: "#dddddd",
	backgroundActive: "#cccccc",
	backgroundTransparent: "rgba(150, 150, 150, 0.5)",
	backgroundTransparentActive: "rgba(50, 50, 50, 0.9)",
	mainMenuItemBackground: "rgba(255,255,255, 1)",
	mainMenuItemBackgroundHover: "rgba(50,50,50, 0.1)",
	mainMenuItemBackgroundActive: "rgba(50,50,50, 0.2)",
	text: "black",
	textAlt: "#555555",
	subText: "#555555",
	borderColor: "#777777",
	boxShadowBottom: "0 1px 2px #bbbbbb",
	boxShadow: "0 1px 2px #bbbbbb",
	boxShadowRaised: "0 4px 2px #bbbbbb",
	dynamicBoxShadow: "rgb(200,200,200)",
	borderBtm: "none",
	shadowColor: "#bbbbbb",
	loadingDark: "#bbbbbb",
	loadingLight: "#F0F2F5",
};

export const darkTheme = {
	...theme,
	main: "rgb(36,37,38)",
	background: "rgb(24,25,26)",
	backgroundAlt: "#444444",
	backgroundHover: "#555555",
	backgroundActive: "#666666",
	backgroundTransparent: "rgba(50, 50, 50, 0.5)",
	backgroundTransparentActive: "rgba(50, 50, 50, 0.9)",
	mainMenuItemBackground: "none",
	mainMenuItemBackgroundHover: "rgba(50,50,50, 0.5)",
	mainMenuItemBackgroundActive: "rgba(100,100,100, 0.7)",
	text: "white",
	textAlt: "white",
	subText: "#999",
	boxShadowBottom: "0 0px 10px #111111",
	boxShadow: "0 0 5px #111111",
	boxShadowRaised: "0 4px 2px #111111",
	dynamicBoxShadow: "rgb(18,18,18)",
	border: "solid 1px #333333",
	shadowColor: "#111111",
	loadingDark: "rgb(36,37,38)",
	loadingLight: "#111111",
};
